import Step from "rivals/components/pages/Registration/Steps/Step";
import BillingForm from "rivals/components/shared/Form/BillingInformation/container";
import strings from "./strings";
import { Props } from "./types";

const { enterBillingInfo } = strings;

function BillingInformationStep(props: Props): JSX.Element {
  return (
    <Step stepNumber={props.stepNumber} title={enterBillingInfo}>
      <BillingForm {...props} />
    </Step>
  );
}

export default BillingInformationStep;
